module.exports = __webpack_public_path__ + "img/AFL_logo_RU_blue.46fd63e7.png";